import React from 'react';

/**
 * 로딩 스피너 컴포넌트
 * 데이터 로딩 중임을 표시하기 위한 공통 컴포넌트
 * 0.2초 이상 로딩이 지속될 때만 표시됩니다.
 */
const LoadingSpinner = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
    </div>
);

/**
 * 로딩 스피너 로직을 제공하는 훅
 * @returns {Object} { isLoading, setIsLoading, showSpinner, LoadingIndicator } 로딩 상태 및 스피너 컴포넌트
 */
export const useLoadingSpinner = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);
    
    React.useEffect(() => {
        let spinnerTimer;
        
        if (isLoading) {
            // 0.2초 후에 스피너를 표시하기 위한 타이머 설정
            spinnerTimer = setTimeout(() => {
                if (isLoading) {
                    setShowSpinner(true);
                }
            }, 300);
        } else {
            setShowSpinner(false);
        }
        
        return () => {
            clearTimeout(spinnerTimer);
        };
    }, [isLoading]);
    
    // 로딩 스피너 컴포넌트
    const LoadingIndicator = showSpinner ? <LoadingSpinner /> : null;
    
    return { isLoading, setIsLoading, showSpinner, LoadingIndicator };
};

export default LoadingSpinner; 